export default __webpack_public_path__ + "static/media/Deepiq_chart (3).c99e181c.png";